import { gql } from '@apollo/client';

export const RELATED_HIRERS = gql`
  query relatedHirers(
    $after: String
    $first: Int
    $filter: HiringOrganizationsFilterInput
    $schemeId: String!
    $doNumericSearch: Boolean!
    $numericId: Int!
    $doOidSearch: Boolean!
    $oid: String!
  ) {
    hiringOrganizations(
      after: $after
      first: $first
      filter: $filter
      schemeId: $schemeId
    ) {
      edges {
        node {
          ...hiringOrganizationFields
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }

    seekAnzAdvertiser(id: $numericId) @include(if: $doNumericSearch) {
      ...hiringOrganizationFields
    }

    hiringOrganization(id: $oid) @include(if: $doOidSearch) {
      ...hiringOrganizationFields
    }
  }

  fragment hiringOrganizationFields on HiringOrganization {
    id {
      value
    }
    name
    seekApiCapabilities {
      relationshipTypeCodes
      applicationMethodCodes
    }
    seekAnzAdvertiserId
  }
`;
